import http from "../http";

export const json = () => {
  return http({
    method: "get",
    url: `/apidocs.json`
  });
};
